import * as yup from 'yup'
import type { Database } from '../types/supabase'
import {
  nullableStringValidator,
  commonFields,
  type InputType,
  type UploadType,
  type EmptyInputType,
  type UploadWithNewReferenceType,
} from './common'

type StorageBehaviourInput = InputType<StorageBehaviourUpload>

type EmptyStorageBehaviourInput = EmptyInputType<StorageBehaviourInput>

type StorageBehaviourTable =
  Database['public']['Tables']['storage_behaviour']['Insert']

type StorageBehaviourUpload = UploadType<StorageBehaviourTable>

export type StorageBehaviourTypes = {
  upload: StorageBehaviourUpload
  withNewReference: UploadWithNewReferenceType<StorageBehaviourUpload>
  input: StorageBehaviourInput
  emptyInput: EmptyStorageBehaviourInput
}

export const schema: yup.ObjectSchema<StorageBehaviourInput> = yup.object({
  ...commonFields,
  distribution: nullableStringValidator,
  storage_behaviour: nullableStringValidator,
  storage_conditions: nullableStringValidator,
})
